import {importGoogleApis} from "./script"

let load:Promise<HTMLScriptElement>|null = null

const setup = () => {
  if (!load) { load = importGoogleApis() }
  return load
}

export default {
  setup
}
